import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { DrumstickIcon, ChiliIcon, SparkleIcon } from './Icons'
import './FloatingElements.css'

const FloatingElements = () => {
  const containerRef = useRef(null)

  useEffect(() => {
    const elements = containerRef.current.querySelectorAll('.floating-element')
    
    elements.forEach((el, index) => {
      // Random starting positions
      const randomX = Math.random() * 50 - 25
      const randomY = Math.random() * 30 - 15
      const randomRotate = Math.random() * 360
      const duration = 4 + Math.random() * 4

      gsap.set(el, {
        x: randomX,
        y: randomY,
        rotation: randomRotate,
      })

      // Floating animation
      gsap.to(el, {
        y: `+=${20 + Math.random() * 20}`,
        x: `+=${10 + Math.random() * 10}`,
        rotation: `+=${30 + Math.random() * 30}`,
        duration: duration,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        delay: index * 0.3,
      })
    })

    // Parallax on scroll
    const handleScroll = () => {
      const scrollY = window.scrollY
      elements.forEach((el, index) => {
        const speed = 0.05 + (index * 0.02)
        const yOffset = scrollY * speed
        gsap.to(el, {
          y: yOffset,
          duration: 0.5,
          ease: 'power1.out',
        })
      })
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="floating-elements-container" ref={containerRef}>
      {/* Left side elements */}
      <div className="floating-element floating-drumstick-1">
        <DrumstickIcon size={80} color="#E4002B" />
      </div>
      <div className="floating-element floating-drumstick-2">
        <DrumstickIcon size={60} color="#FF6B6B" />
      </div>
      <div className="floating-element floating-chili-1">
        <ChiliIcon size={50} />
      </div>
      
      {/* Right side elements */}
      <div className="floating-element floating-drumstick-3">
        <DrumstickIcon size={70} color="#E4002B" />
      </div>
      <div className="floating-element floating-drumstick-4">
        <DrumstickIcon size={55} color="#8B0000" />
      </div>
      <div className="floating-element floating-chili-2">
        <ChiliIcon size={40} />
      </div>

      {/* Sparkles */}
      <div className="floating-element floating-sparkle-1">
        <SparkleIcon size={25} />
      </div>
      <div className="floating-element floating-sparkle-2">
        <SparkleIcon size={20} />
      </div>
      <div className="floating-element floating-sparkle-3">
        <SparkleIcon size={30} />
      </div>
      <div className="floating-element floating-sparkle-4">
        <SparkleIcon size={22} />
      </div>
    </div>
  )
}

export default FloatingElements
